import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PLAYOFF_SERIES_SMALL_SCREEN_QUERY, PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY } from '../../styles';

export const ScoreboardContentContainer = styled.div`
    width: 186px;
    height: 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.large} {
        width: 249px;
        height: 59px;
    }
`;

export const RoundAndSeriesMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    white-space: nowrap;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
    }
    
    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        ${BaseStyle.Mixins.gaps.small}
    }
}
`;

export const BannerLogo = styled.img`
    height: 24px;
    max-width: 275px;
    margin-bottom: 12px;

    ${BaseStyle.Mixins.screenSizes.large} {
        height: 33px;
        max-width: 350px;
    }

    ${PLAYOFF_SERIES_SMALL_SCREEN_QUERY} {
        display: none;
    }

    ${PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY} {
        display: none;
    }

    ${BaseStyle.Mixins.screenSizes.small} {
        display: none;
    }
`;

export const SeriesStatusMessage = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']}

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14b']}
    }
`;
